import { render, staticRenderFns } from "./applyinvoice.vue?vue&type=template&id=94973b9a&scoped=true&"
import script from "./applyinvoice.vue?vue&type=script&lang=js&"
export * from "./applyinvoice.vue?vue&type=script&lang=js&"
import style0 from "./applyinvoice.vue?vue&type=style&index=0&id=94973b9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94973b9a",
  null
  
)

export default component.exports